/* eslint-disable class-methods-use-this */
/* eslint-disable no-param-reassign */
/* eslint-disable prefer-destructuring */

import $ from 'jquery';
import cookie from 'react-cookies';
import { CSRF_TOKEN_NAME } from 'utils/envVars';
import Constants from '../constants';

const { apiHost: host, internalApiHost } = Constants;

const EBS_TRAFFIC_PERCENTAGE = 1;

const getHost = (path) => {
  // TODO: Fix non-ebs compliant endpoints on the backend
  const blacklistedPaths = ['campaigns/send'];

  if (
    Math.random() <= EBS_TRAFFIC_PERCENTAGE &&
    blacklistedPaths.every((item) => !path.includes(item))
  ) {
    return internalApiHost;
  }

  return host;
};

const paramStringFromObject = (params) => {
  const searchParams = new URLSearchParams();

  Object.keys(params).map((key) => searchParams.set(key, params[key]));

  return `?${searchParams.toString()}`;
};

const createHeadersAccess = (accessToken) => {
  return {
    ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
  };
};

const createHeadersRefresh = () => {
  return {
    'X-CSRF-TOKEN': cookie.load(CSRF_TOKEN_NAME),
  };
};

class Requests {
  authApi = null;

  setAuthApi(authApi) {
    this.authApi = authApi;
  }

  get(path, params) {
    const authApi = this.authApi;
    const requestHost = getHost(path);

    const paramString = params ? paramStringFromObject(params) : '';

    const promise = new Promise(function (resolve) {
      $.ajax({
        url: `${requestHost}${path}${paramString}`,
        type: 'GET',
        headers: createHeadersAccess(authApi?.accessToken),
        timeout: 30000,
        success: (data) => {
          resolve(data);
        },
        error: async () => {
          resolve(false);
        },
      });
    });
    return promise;
  }

  post(
    path,
    data,
    refreshHeaders,
    method = 'POST',
    rejectErrors = false,
    withCredentials = false,
  ) {
    const authApi = this.authApi;
    const promise = new Promise((resolve, reject) => {
      const requestHost = getHost(path);

      const headers = refreshHeaders
        ? createHeadersRefresh()
        : createHeadersAccess(authApi?.accessToken);

      $.ajax({
        url: `${requestHost}${path}`,
        type: method,
        headers,
        xhrFields: withCredentials ? { withCredentials: true } : undefined,
        // async: false,
        contentType: 'application/json; charset=utf-8',
        dataType: 'json',
        data: JSON.stringify(data),
        success(data) {
          resolve(data);
        },
        error: async (result) => {
          const isBadRequest = result.status === 400;

          if (isBadRequest) {
            if (rejectErrors) {
              const { errors } = result.responseJSON;
              return reject(errors);
            }

            return resolve(false);
          }

          resolve(false);
        },
      });
    });
    return promise;
  }

  patch(path, data, refreshHeaders, rejectErrors = false) {
    return this.post(path, data, refreshHeaders, 'PATCH', rejectErrors);
  }

  put(path, data, refreshHeaders, rejectErrors = false) {
    return this.post(path, data, refreshHeaders, 'PUT', rejectErrors);
  }

  delete(path, data, refreshHeaders, rejectErrors = false) {
    return this.post(path, data, refreshHeaders, 'DELETE', rejectErrors);
  }

  postWithCredentials(path, data, refreshHeaders, rejectErrors = false) {
    return this.post(path, data, refreshHeaders, 'POST', rejectErrors, true);
  }

  postReject(path, data, refreshHeaders) {
    // Totally temporary... remove me when networking is fixed
    return this.post(path, data, refreshHeaders, 'POST', true);
  }

  postFormData(path, data) {
    const authApi = this.authApi;
    const promise = new Promise((resolve) => {
      const requestHost = getHost(path);

      const headers = createHeadersAccess(authApi?.accessToken);

      $.ajax({
        url: `${requestHost}${path}`,
        type: 'POST',
        headers,
        async: false,
        processData: false,
        contentType: false,
        data,
        success(data) {
          resolve(data);
        },
        error: async (result) => {
          console.log('API ERROR', JSON.stringify(result));
          resolve(false);
        },
      });
    });
    return promise;
  }
}

// Export as a singleton, so we can alter it's state to do things like changing which access token is used
export default new Requests();
export { host };
